export default "__VITE_ASSET__CVHtA2Py__"